import React, { useRef } from 'react'
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import '../../scss/_Spinner.scss'

const Spiner = (props) => {
  const dialogRef = useRef(null)
  const { opt = false } = props

  return (
    <Dialog
      open={opt}
      ref={dialogRef}
      aria-labelledby="loading-dialog-title"
      aria-describedby="loading-dialog-description"
      fullWidth
      maxWidth="xs"
      className="easybuy-spinner-dialog"
      PaperProps={{
        className: 'easybuy-spinner-paper'
      }}
    >
      <DialogContent className="easybuy-spinner-content">
        <div className="easybuy-spinner">
          <div className="easybuy-spinner-ring"></div>
          <div className="easybuy-spinner-center"></div>
        </div>

        <DialogTitle
          id="loading-dialog-title"
          className="easybuy-spinner-title"
        >
          Cargando
        </DialogTitle>

        <div id="loading-dialog-description" className="easybuy-spinner-text">
          Por favor espera un momento...
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default Spiner
